//
//
//
//
//
//
//
//
//
export default {
  name: 'UserManage',
  data: function data() {
    return {
      isRouterAlive: true
    };
  },
  created: function created() {
    console.log('created UserManage');
  },
  activated: function activated() {
    var _this = this;

    console.log('activated UserManage');
    this.isRouterAlive = false;
    this.$nextTick(function () {
      return _this.isRouterAlive = true;
    });
  }
};